import { HALApiService } from '../hal-api.service.js';

export const employeePerformanceService = {
  options: (query = {}) => HALApiService.get('/reports/employee-performance/options', query),
  report: (criteria) => HALApiService.get('/reports/employee-performance', { criteria }),
  saveTarget: (data) => HALApiService.post('/reports/employee-performance/targets', data),
};
